import { useLayoutEffect } from "react";
const useCursor = (el) => {
    useLayoutEffect(() => {
        if (!el) {
            return;
        }
        const currentCursor = getComputedStyle(el).cursor;
        el.style.cursor = currentCursor !== "auto" ? currentCursor : "default";
    }, [el]);
};
export default useCursor;
//# sourceMappingURL=useCursor.js.map